import { axios } from "../lib";
import * as endpoints from "./apiEndpoints";

class CodeService {
  static loadCodes() {
    const url = `${endpoints.BASE_URL}${endpoints.CODES}`;
    return axios.get(url).then((response) => response.data);
  }

  static getCode(id) {
    const url = `${endpoints.BASE_URL}${endpoints.CODES}/${id}`;
    return axios.get(url).then((response) => response.data);
  }

  static createCode(code) {
    const url = `${endpoints.BASE_URL}${endpoints.CODES}`;
    const body = {
      code
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static updateCode(code) {
    const url = `${endpoints.BASE_URL}${endpoints.CODES}/${code.id}`;
    const body = {
      code
    };

    return axios.put(url, body).then((response) => response.data);
  }

  static deleteCode(id) {
    const url = `${endpoints.BASE_URL}${endpoints.CODES}/${id}`;
    return axios.delete(url).then((response) => response.data);
  }
}

export default CodeService;
